import { isDevelopment } from './environments';

// util to have log content in development env only
export const logInDevelopment = (...args: any) => {
  if (isDevelopment) {
    console.log(...args);
  }
};
